/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { MPlugins } from 'js/entry/util.js';
import { $ } from 'js/entry/base.js';
import { mjt } from 'js/entry/i18ntexts.js';
import { MVMediaPage, Lightbox } from 'js/entry/media.js';
import { getCombinedApprovalVotesStatusTypes } from './inquirer_voting.js';


function applyApprovalVotesToResultView( voting_id, $result_elem, object_item, inquirer_voting, call_plugins ) {
	// cleanup
	const x_votings_classes_arr = getCombinedApprovalVotesStatusTypes('x-votings-');
	$result_elem.find('.x-votings').removeClass('x-votings '+x_votings_classes_arr.join(' '));
	$result_elem.find('.mm-votings').remove();

	// apply
	const combined_approval_votes = inquirer_voting.getAllCombinedApprovalVotesByMedia();
	for( let media_id in combined_approval_votes ) {
		if( !combined_approval_votes.hasOwnProperty(media_id) ) continue;
		const counts = combined_approval_votes[media_id];

		//console.log({media_id,counts});

		const $media_item = $result_elem.find('div[data-mj_mid='+media_id+']');
		if( $media_item.length ) {
			const cs = counts.combined_status;
			$media_item.addClass('x-votings x-votings-'+cs);

			const $media_menu = $media_item.find('.media_menu');
			if( $media_menu.length ) {
				$('<div class="mmb mm-votings mm-votings-'+cs+'" title="voting_id'+voting_id+'"></div>')
					.data('mj-custom-tooltip', () => {
						return '<div class="lbl">'+mjt('ctx-menu-votings-result-from-approval-votes')+': </div>'
							+  '<div class="votings-feedback-tooltip">'+inquirer_voting.getApprovalVotesResultsHTML(media_id)+'</div>';
					} )
					.appendTo($media_menu);
			}
		}
	}

	if( call_plugins ) {
		MPlugins.callOnAllPluginsOfType('MediaResultInfoView','afterApplyInquirerApprovalVotesToResultView',true,voting_id,object_item,inquirer_voting);
	}
}



/*** .. final votes ***/

function applyFinalVotesToResultView( voting_id, $result_elem, object_item, inquirer_voting, call_plugins ) {
	$result_elem.find('.x-votings-final').removeClass('x-votings-final x-votings-final-in x-votings-final-out');

	const final_votes = inquirer_voting.getFinalVotes();
	for( const media_id in final_votes ) {
		if( !final_votes.hasOwnProperty(media_id) ) continue;
		const vote_value = final_votes[media_id];
		const $media_item = $result_elem.find('div[data-mj_mid='+media_id+']');
		if( $media_item.length ) {
			if( vote_value!==null ) {
				if( vote_value ) {
					$media_item.addClass('x-votings-final x-votings-final-in');
				} else {
					$media_item.addClass('x-votings-final x-votings-final-out');
				}
			}
		}
	}

	if( call_plugins ) {
		MPlugins.callOnAllPluginsOfType('MediaResultInfoView','afterApplyInquirerFinalVotesToResultView',true,voting_id,object_item,inquirer_voting);
	}
}


function applyFinalVotesToCtxToolbarExtraElem( $finalVotes_extraElem, inquirer_voting, sel_media_ids ) {
	const $both = $('#media-ctxtb-final-votes-approve,#media-ctxtb-final-votes-reject',$finalVotes_extraElem).removeClass('partial checked');
	const combinedState = inquirer_voting.getFinalVotesCombinedState(sel_media_ids);
	if( combinedState===true ) {
		// all true
		$('#media-ctxtb-final-votes-approve',$finalVotes_extraElem).addClass('checked');
	} else if( combinedState===false ) {
		// all false
		$('#media-ctxtb-final-votes-reject',$finalVotes_extraElem).addClass('checked');
	} else if( combinedState===undefined ) {
		// undefined yet
	} else {
		// half/half
		$both.addClass('partial');
	}
}



export function onInquirerResultViewNodesLoaded( $result_elem, object_id, object_item, inquirer_voting, loaded_media_ids ) {
	const voting_id = object_item.x_id || 0;
	if( inquirer_voting.hasFinalVotesStarted() ) {
		applyFinalVotesToResultView(voting_id,$result_elem,object_item,inquirer_voting,false);
	}
	applyApprovalVotesToResultView(voting_id,$result_elem,object_item,inquirer_voting,false);
}



var m_last_voting_id = null;
var m_last_voting_changed_dt = null;
var m_last_rv_change_count = 0;

export function onInquirerResultViewSelectionChanged( $result_elem, object_id, object_item, inquirer_voting, sel_media_ids ) {
	const voting_id = object_item.x_id || 0;

	var ui_states = {
		voting_changed: false,
		result_view_changed: false,
		approval_votes_result: false,
		approval_votes_ctx_toolbar: false,
		final_votes_result: false,
		final_votes_ctx_toolbar: false,
		final_votes_ctx_toolbar_info: false,
	};

	if( m_last_voting_id!==voting_id ) {
		ui_states.voting_changed = true;
		if( m_last_voting_changed_dt!==inquirer_voting.voting.changed_dt ) {
			ui_states.voting_changed = true;
		}
		m_last_voting_changed_dt = inquirer_voting.voting.changed_dt;
		m_last_voting_id = voting_id;
	}

	const rv_widget = $result_elem.data('mjMjMediaResultViewWidget');

	const rv_change_count = rv_widget.getChangeCount();
	if( m_last_rv_change_count!==rv_change_count ) {
		ui_states.result_view_changed = true;
		m_last_rv_change_count = rv_change_count;
	}


	ui_states.approval_votes_result = true;
	ui_states.approval_votes_ctx_toolbar = true;

	if( inquirer_voting.hasFinalVotesStarted() ) {
		// final votes phase started, at least:
		ui_states.final_votes_result = true;
		if( inquirer_voting.hasFinalVotesSubmitted() ) {
			// .. and submitted
			ui_states.final_votes_ctx_toolbar_info = true;
		} else {
			// .. and still in-progress
			ui_states.final_votes_ctx_toolbar = true;
		}
	}

	var ctx_menu_additions_bindings = {};
	var ctx_menu_entries = [];

	if( ui_states.final_votes_result ) {
		if( ui_states.voting_changed || ui_states.result_view_changed ) applyFinalVotesToResultView(voting_id,$result_elem,object_item,inquirer_voting,true);
	}
	if( ui_states.final_votes_ctx_toolbar ) {
		// controls for approvers to cast their votes
		const $finalVotes_extraElem = $(
			'<li id="ctx-toolbar-votings1" class="submenu media-ctx-menu-votings-section"><span class="icon icon-approve icon-coloured"></span>'+mjt('ctx-menu-votings-final-votes')+
				'<ul>'+
					'<li id="media-ctxtb-final-votes-approve" class="media-ctxtb-final-votes-action"><span class="state">&nbsp;</span><span class="text">'+mjt('ctx-menu-votings-final-votes-approve-action')+'</span></li>'+
					'<li id="media-ctxtb-final-votes-reject" class="media-ctxtb-final-votes-action"><span class="state">&nbsp;</span><span class="text">'+mjt('ctx-menu-votings-final-votes-reject-action')+'</span></li>'+
					'<li id="media-ctxtb-final-votes-default" class="media-ctxtb-final-votes-action"><span class="state">&nbsp;</span><span class="text">'+mjt('ctx-menu-votings-final-votes-default-action')+'</span></li>'+
				'</ul>'+
			'</li>'
		);

		applyFinalVotesToCtxToolbarExtraElem($finalVotes_extraElem,inquirer_voting,sel_media_ids);

		// bind handlers for approve & reject actions ..
		const setFinalVotesValue_done = function( inquirer_voting ) {
			applyFinalVotesToResultView(voting_id,$result_elem,object_item,inquirer_voting,true);
			applyFinalVotesToCtxToolbarExtraElem($finalVotes_extraElem,inquirer_voting,sel_media_ids);
		};
		ctx_menu_additions_bindings['media-ctxtb-final-votes-approve'] = function(evt) {
			const checked = $(evt.currentTarget).hasClass('checked');
			const vote_value = checked ? null : true;
			inquirer_voting.setFinalVotesValue( sel_media_ids, vote_value, setFinalVotesValue_done );
		};
		ctx_menu_additions_bindings['media-ctxtb-final-votes-reject'] = function(evt) {
			const checked = $(evt.currentTarget).hasClass('checked');
			const vote_value = checked ? null : false;
			inquirer_voting.setFinalVotesValue( sel_media_ids, vote_value, setFinalVotesValue_done );
		};
		ctx_menu_additions_bindings['media-ctxtb-final-votes-default'] = function(evt) {
			inquirer_voting.setFinalVotesFromApprovalVotes( sel_media_ids, setFinalVotesValue_done );
		};
		ctx_menu_entries.push($finalVotes_extraElem);
	}

	if( ui_states.final_votes_ctx_toolbar_info ) {
		let list_html = '';
		if( sel_media_ids.length == 1 ) {
			const final_votes_results_html = inquirer_voting.getFinalVotesResultsHTML(sel_media_ids);
			if( final_votes_results_html!=='' ) {
				list_html += '<li class="infosubmenu">'+final_votes_results_html+'</li>';
			}
		} else {
			$.each( sel_media_ids, function( i, val ) {
				const sel_id = 'media-ctxtb-votings-approval-final-votes-info-no-'+val;
				ctx_menu_additions_bindings[sel_id] = function(e) {
					if( rv_widget ) rv_widget.selectVisibleNodes([val],true,true);
					Lightbox.selectVisibleNodes([val],true);
				};
				const final_votes_results_html = inquirer_voting.getFinalVotesResultsHTML([val]);
				if( final_votes_results_html!=='' ) {
					list_html += '<li id="'+sel_id+'" class="submenu media-ctxtb-votings-approval-final-votes-info">'+val+'<ul><li class="infosubmenu">'+final_votes_results_html+'</li></ul></li>';
				}
			} );
		}

		if( list_html!=='' ) {
			const $finalVotesInfo_extraElem = $(
				'<li id="ctx-toolbar-votings2" class="submenu media-ctx-menu-votings-section"><span class="icon icon-approve icon-coloured"></span>'+mjt('ctx-menu-votings-result-from-final-votes')+
					'<ul>'+
						list_html+
					'</ul>'+
				'</li>'
			);
			ctx_menu_entries.push($finalVotesInfo_extraElem);
		}
	}

	if( ui_states.approval_votes_result ) {
		if( ui_states.voting_changed || ui_states.result_view_changed ) applyApprovalVotesToResultView(voting_id,$result_elem,object_item,inquirer_voting,true);
	}

	if( ui_states.approval_votes_ctx_toolbar ) {
		let list_html = '';
		if( sel_media_ids.length == 1 ) {
			const approval_votes_results_html = inquirer_voting.getApprovalVotesResultsHTML(sel_media_ids[0],true);
			list_html += '<li class="infosubmenu">'+approval_votes_results_html+'</li>';
		} else {
			$.each( sel_media_ids, function( i, val ) {
				const sel_id = 'media-ctxtb-votings-approval-votes-info-no-'+val;
				ctx_menu_additions_bindings[sel_id] = function(e) {
					if( rv_widget ) rv_widget.selectVisibleNodes([val],true,true);
					Lightbox.selectVisibleNodes([val],true);
				};
				const approval_votes_results_html = inquirer_voting.getApprovalVotesResultsHTML(val,true);
				list_html += '<li id="'+sel_id+'" class="submenu media-ctxtb-votings-approval-votes-info">'+val+'<ul><li class="infosubmenu">'+approval_votes_results_html+'</li></ul></li>';
			} );
		}

		if( list_html!=='' ) {
			const $approverVotesInfo_extraElem = $(
				'<li id="ctx-toolbar-votings3" class="submenu media-ctx-menu-votings-section"><span class="icon icon-approve icon-coloured"></span>'+mjt('ctx-menu-votings-result-from-approval-votes')+
					'<ul>'+
						list_html+
					'</ul>'+
				'</li>'
			);
			ctx_menu_entries.push($approverVotesInfo_extraElem);
		}
	}
	MVMediaPage.contextMenuDynamicContent({bindings: ctx_menu_additions_bindings, html: ctx_menu_entries});
}
